module.exports = __webpack_public_path__ + "static/media/gochi_noimg-ver4.aefe4951.jpg";